import * as React from 'react';
import styled from 'styled-components';
import {
  compose,
  space,
  color,
  layout,
  typography,
  SpaceProps,
  ColorProps,
  LayoutProps,
  TypographyProps,
} from 'styled-system';
import { nanoid } from 'nanoid';
export type IconProps = SpaceProps & ColorProps & LayoutProps & TypographyProps;
const SvgComponent = React.forwardRef<
  SVGSVGElement,
  React.SVGProps<SVGSVGElement> & {
    title?: any;
  }
>(({ title, ...props }, svgRef) => {
  const [titleId] = React.useState(() => (title ? nanoid() : undefined));
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      width="1em"
      height="1em"
      ref={svgRef}
      aria-labelledby={titleId}
      {...props}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.5 3C4.5 2.44772 4.94772 2 5.5 2H18.5C19.0523 2 19.5 2.44772 19.5 3C19.5 3.55228 19.0523 4 18.5 4H5.5C4.94772 4 4.5 3.55228 4.5 3Z"
        fill="currentColor"
      />
      <path
        d="M6.70715 12.7072C6.31663 13.0977 5.68346 13.0977 5.29294 12.7072C4.90242 12.3167 4.90242 11.6835 5.29294 11.293L11.2929 5.29298C11.6835 4.90246 12.3166 4.90246 12.7072 5.29298L18.7072 11.293C19.0977 11.6835 19.0977 12.3167 18.7072 12.7072C18.3166 13.0977 17.6835 13.0977 17.2929 12.7072L13 8.4143L13 21.0001C13 21.5524 12.5523 22.0001 12 22.0001C11.4478 22.0001 11 21.5524 11 21.0001L11 8.4143L6.70715 12.7072Z"
        fill="currentColor"
      />
    </svg>
  );
});
export const IconsArrowToTop = styled(SvgComponent)<IconProps>(
  {
    flex: 'none',
    verticalAlign: 'middle',
  },
  compose(space, color, layout, typography)
);
